import { createRouter, createWebHistory, RouteRecordRaw } from 'vue-router'

import mortgageRoutes, { mortgageRouteNames } from '@/pages/mortgage'
import { isDev } from '@/shared/lib/env'
import { routesNames, authRoutes, chatmessageRoutes, reportsRoutes, userRoutes, infoRoutes } from './routes'
import { authGuard } from './guards'

const homeRoute: RouteRecordRaw = {
  path: '',
  name: 'Home',
  beforeEnter: [authGuard],
  component: () => import('@/pages/HomePage'),
  meta: { title: 'Главная — Inpocket Ипотека' }
}

const homeWithLayout: RouteRecordRaw = {
  path: '',
  component: () => import('@/shared/components/TheLayout.vue'),
  children: [homeRoute],
  meta: {
    layoutClass: '"bg-gradient-to-r from-[#D0D0D0] via-[#838383] to-[#838383]'
  }
}

const notFoundRoute: RouteRecordRaw = {
  path: '/:pathMatch(.*)',
  redirect: { name: mortgageRouteNames.list }
}

const authorizedPart: RouteRecordRaw = {
  path: '',
  component: () => import('@/shared/components/TheLayout.vue'),
  beforeEnter: [authGuard],
  children: [
    mortgageRoutes,
    reportsRoutes,
    userRoutes,
    ...infoRoutes,
    chatmessageRoutes,
    {
      path: 'domrf',
      name: 'Domrf',
      component: () => import('@/pages/DomrfPage')
    }
  ]
}

const root: RouteRecordRaw = {
  path: '',
  name: 'Root',
  children: [homeWithLayout, authorizedPart, authRoutes, notFoundRoute]
}

if (isDev()) {
  authorizedPart.children.push({
    path: 'test',
    children: [
      {
        path: 'calculator',
        name: 'test-calc',
        component: () => import('@/pages/TEST/MortgageCalculatorPage')
      },
      {
        path: 'app/:id?',
        name: 'test-app',
        component: () => import('@/pages/TEST/MortgageAppPage')
      }
    ]
  })
}

const router = createRouter({
  history: createWebHistory(),
  routes: [root]
})

router.beforeResolve((to, from, next) => {
  // Находим название страницы, если он прописан в мета данных
  const title = to.matched.reduce((t, r) => (t = (r?.meta.title as string) || t), 'Inpocket Ипотека')
  window.document.title = title

  next()
})

export { router, routesNames }
